// extracted by mini-css-extract-plugin
export default {"note-textarea":"styles_note-textarea__2jeKi"};